import * as types from './actionTypes';

export default () => (dispatch) => {
  dispatch({
    type: types.SUCCESS_TOAST_DISMISSED,
    payload: {
      display: false,
      message: '',
      timeout: 0,
    },
  });
};
